import {Location} from "../../types/Location";

export let LocationUtility = {
    locationLabel: function (location: Location) {
        if (location.label) {
            return location.label
        } else if (location.street_address_1) {
            return location.street_address_1
        } else if (location.city || location.state) {
            if (location.city && location.state) {
                return location.city + ', ' + location.state
            } else {
                return location.city || location.state
            }
        } else if (location.zip) {
            return location.zip
        } else {
            return 'No location defined'
        }
    }
};
